import { Typography } from "@packages/ds";
import styled from "styled-components";

export const Wrapper = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 -32px;
  padding: 14px 0;
  gap: 32px;
  background: linear-gradient(
    260deg,
    #d6fc6a -7.52%,
    #fddbd0 16.49%,
    #f177f4 58.84%,
    #4a5af2 113.34%,
    #4a5af2 162.75%
  );
`;

export const BodyText = styled(Typography.BodyText)`
  color: var(--section-night-color, var(--night));
`;
